<template>
  <div v-if="!bannerPlaceHolderForGoForAppOnlySale" class="Home home-background">
    <BannerPlaceHolderMsg
      v-if="bannerPlaceHolder && bannerPlaceHolder.status"
      :bannerStyle="bannerPlaceHolder && bannerPlaceHolder.styles"
      :bannerMsg="bannerPlaceHolder && bannerPlaceHolder.text"
    >
    </BannerPlaceHolderMsg>
    <div >
      <div v-if="homeLandingBanners && homeLandingBanners.length">
        <div class="headtop prelative" v-if="isDesktop">
          <carousel
            :key="webcategory"
            ref="my-carousel" :perPage='1'
            :navigationEnabled="true" :paginationEnabled="true"
            navigationNextLabel=" " navigationPrevLabel=" "
            :loop="true" :autoplay="true" :paginationPadding="7"
            :autoplayTimeout="6000" :speed="500"
            paginationActiveColor="#117a7a" class="bannerview"
            @pageChange="bannerPageEventHandler"
          >
            <slide v-for="(bimg, index) in homeLandingBanners" :key="index">
              <div  @click="triggerCarouselEvents(index, bimg)" class='prelative shimmerBgColor'>
                <div v-if="getExtension(bimg.image) === 'mp4'">
                  <a :href="bimg.link" :title="bimg.alt">
                    <video style="width:100%" v-bind:autoplay="{true: getExtension(bimg.image) === 'mp4'}">
                      <source :data-src="isComboActive ? getHomeBannerImage(bimg.image) : htpath + bimg.image" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>
                  </a>
                </div>
                <div class="shimmerBgColor" v-else>
                  <a v-if="bimg.navigation_link" class="clickable d-inline-block w-100" :href="getUrl(bimg.navigation_link)" :target="bimg.navigation_link==='https://view.gmetri.com' && authStatus ? '_blank' : '_self'" :aria-label="bimg.promotion_name || 'Home Banner'">
                    <img class="w-100  img-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.image) : htpath + bimg.image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="1500" height="512">
                  </a>
                  <router-link v-else :to="bimg.link ? bimg.link : ''" :aria-label="bimg.promotion_name || 'Home Banner'">
                    <img class="w-100  img-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.image) : htpath + bimg.image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="1500" height="512">
                  </router-link>
                </div>
                <div v-if="bimg.is_split_banner && (bimg.navigation_link || bimg.right_navigation_link)" class='row splitted-navigation-container'>
                  <a :href="getUrl(bimg.navigation_link)" :target="bimg.navigation_link === 'https://view.gmetri.com' && authStatus ? '_blank' : '_self'" class='col-6'></a>
                  <a :href="getUrl(bimg.right_navigation_link)" :target="bimg.right_navigation_link === 'https://view.gmetri.com' && authStatus ? '_blank' : '_self'" class='col-6'></a>
                </div>
                <div v-else-if="bimg.is_split_banner && (bimg.link || bimg.right_link)" class='row splitted-navigation-container'>
                  <router-link :to="bimg.link ? bimg.link : ''" class='col-6'></router-link>
                  <router-link :to="bimg.right_link ? bimg.right_link : ''" class='col-6'></router-link>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="headtop prelative" v-else>
          <carousel :key="webcategory" :perPage='1' :navigationEnabled="true" :paginationEnabled="true" navigationNextLabel=" " ref="my-carousel"
            navigationPrevLabel=" " :autoplay="true" :class="isDesktop ? 'bannerview' : 'mobileBannerView'" :paginationPadding="1"
            :autoplayTimeout="4000" :speed="500" :loop="true" :paginationSize="6" :paginationColor="'#979a9f'" @pageChange="bannerPageEventHandler"
          >
            <slide v-for="(bimg, index) in homeLandingBanners" :key="index">
              <div v-bannerImageLoad="getBannerImpressionData(bimg, index)" @click="triggerCarouselEvents(index, bimg)" class='prelative shimmerBgColor'>
                <a v-if="bimg.navigation_link"  class="d-inline-block w-100 clickable" :href="getUrl(bimg.navigation_link)" :target="bimg.navigation_link === 'https://view.gmetri.com' && authStatus? '_blank' : '_self'">
                  <img class="w-100  img-h-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.mobile_image) : htpath + bimg.mob_image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="375" height="482" v-if="bannerPlaceHolderForCarouselSize">
                  <img class="w-100  img-h-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.mobile_image) : htpath + bimg.mob_image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="768" height="600" v-if="!bannerPlaceHolderForCarouselSize">
                </a>
                <router-link v-else :to="bimg.link ? bimg.link : ''" class="d-inline-block w-100">
                  <img class="w-100  img-h-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.mobile_image) : htpath + bimg.mob_image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="375" height="482" v-if="bannerPlaceHolderForCarouselSize">
                  <img class="w-100  img-h-auto" @load="loadimage($event)" :loading="index<=1?'eager':'lazy'" :src="isComboActive ? getHomeBannerImage(bimg.mobile_image) : htpath + bimg.mob_image" :alt="bimg.alt || bimg.title || 'Home Banner'" width="768" height="600" v-if="!bannerPlaceHolderForCarouselSize">
                </router-link>
                <div v-if="bimg.is_split_banner && (bimg.navigation_link || bimg.right_navigation_link)" class='row splitted-navigation-container'>
                  <a :href="getUrl(bimg.navigation_link)" :target="bimg.navigation_link === 'https://view.gmetri.com' && authStatus ? '_blank' : '_self'" class='col-6'></a>
                  <a :href="getUrl(bimg.right_navigation_link)" :target="bimg.right_navigation_link === 'https://view.gmetri.com' && authStatus ? '_blank' : '_self'" class='col-6'></a>
                </div>
                <div v-else-if="bimg.is_split_banner && (bimg.link || bimg.right_link)" class='row splitted-navigation-container'>
                  <router-link :to="bimg.link ? bimg.link : ''" class='col-6'></router-link>
                  <router-link :to="bimg.right_link ? bimg.right_link : ''" class='col-6'></router-link>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
      <Countdown
      :starttime="timerData.startDate"
      :endtime="timerData.endDate"
      :color="timerData.timerColor"
      v-if="timerData.showCountDown && true"
      :showTimer="timerData.showTimer"
      :pretext="timerData.liveSaleText"
      :mobileUI="isDesktop ? false : true" 
      v-on:getLiveSaleText="getSaleTextToShow" 
      :showEarlyText="timerData.showEarlyText" 
    />
    <div class="clearfix"></div>
    <div class="fullWidth categorySection" v-if="keepExploringData && Object.keys(keepExploringData).length && isShowOnlyKeepExploringWidget">
      <HomeWidgetsWrapper
        v-for="(item, key, index) in keepExploringData"
        :key="index"
        :bannerPlaceHolderForFireWorkStoryBlock="bannerPlaceHolderForFireWorkStoryBlock"
        :bannerPlaceHolderForFireWorkGrid="bannerPlaceHolderForFireWorkGrid"
        :widgetType="getType(item)"
      >
        <component
          :renderName="item && item[item.length - 1] && item[item.length - 1].length >= 3 && item[item.length - 1][2]"
          :renderData="item"
          :isWidgetProduct = true
          :homepath="homepath"
          :is="getComponetToRender(item, key)"
          :widgetType="getType(item)"
          callerComp='homePage'
        ></component>
      </HomeWidgetsWrapper>
    </div>
    <div class="fullWidth categorySection" v-if="homeLandingWidgets && Object.keys(homeLandingWidgets).length">
      <HomeWidgetsWrapper
        v-for="(item, key, index) in homeLandingWidgets"
        :key="index"
        :bannerPlaceHolderForFireWorkStoryBlock="bannerPlaceHolderForFireWorkStoryBlock"
        :bannerPlaceHolderForFireWorkGrid="bannerPlaceHolderForFireWorkGrid"
        :widgetType="getType(item)"
      >
        <component
          :renderName="item && item[item.length - 1] && item[item.length - 1].length >= 3 && item[item.length - 1][2]"
          :renderData="item"
          :homepath="homepath"
          :is="getComponetToRender(item, key)"
          :widgetType="getType(item)"
          callerComp='homePage'
        ></component>
      </HomeWidgetsWrapper>
</div>
  </div>
  <script type="application/ld+json">
    {
      "@context": "http://schema.org",
      "@type": "Corporation",
      "name": "The Souled Store",
      "legalName" : "The Souled Store",
      "description": "We, at The Souled Store, love what we do- designs, products, marketing, and everything in between. Our goal is to give everyone something they'll love, something they can use to express themselves, and, simply put, something to put a smile on their face.",
      "url": "https://www.thesouledstore.com/",
      "logo": "https://www.thesouledstore.com//static/img/newlogo.8dcc6cc.png",
      "foundingDate": "2013",
      "foundingLocation": "Mumbai",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "224, Tantia Jogani Industrial Premises Opp Lodha Excelus, Jivraj Ramji Boricha Marg, Lower Parel East, Mumbai, Maharashtra",
        "addressLocality": "Lower Parel East",
        "addressRegion": "Mumbai, Maharashtra",
        "postalCode": "400011, IN",
        "addressCountry": "India"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "telephone": "022 68493328",
        "email": "connect@thesouledstore.com",
        "hoursAvailable": "Mon to Fri: 09.30 am to 10.00 pm, Sat-Sun: 09.30 am to 7.00 pm"
      },

      "sameAs": [
        "https://www.linkedin.com/company/the-souled-store-pvt-ltd-/about/",
        "https://www.instagram.com/TheSouledStore/",
        "https://www.facebook.com/souledstore/",
        "https://twitter.com/TheSouledStore",
        "https://www.youtube.com/channel/UC1LkdB8GTrMEwFF_yzqytoA",
        "https://www.crunchbase.com/organization/the-souled-store"
      ]
}
  </script>
  <script type="application/ld+json">
{
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://www.thesouledstore.com/",
    "potentialAction": [{
    "@type": "SearchAction",
    "target": "https://www.thesouledstore.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }]
}
</script>
  </div>
  <div v-else class="goForAppNlySale-wrapper" v-dynamic-min-height>
    <div class="headtop prelative">
      <div v-for="(bimg, index) in AppLandingBanners" :key="index">
        <div v-dynamic-min-height class='prelative'>
          <router-link :to="bimg.url ? bimg.url : ''" :aria-label="bimg.promotion_name || 'Home Banner'">
            <img :data-src="isDesktop ? bimg.image : bimg.mobile_image" :alt="bimg.name || 'TSS Banner'">
            <div class="show-more-btn" v-if="bimg.is_viewmore_button_visible">
              <span class='show-more-btn-txt'>{{bimg.name}}</span>
            </div>
          </router-link>
          <div v-if="bimg.is_split_banner" class='row splitted-navigation-container'>
            <div aria-label="left url" class="col-6 pointer" @click="appOpenHandler('Play Store')"></div>
            <div aria-label="right url" class='col-6 pointer'  @click="appOpenHandler('App Store')"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  import Vue from 'vue'
  import {appMixins} from '../assets/js/appMixins'
  import {Carousel, Slide} from 'vue-carousel'
  import {metaElements} from '../assets/js/metaElements'
  import {mapGetters} from 'vuex'
  import moment from 'moment/src/moment'
  import getLastPage from '../assets/js/getLastPage'
  import webPush from '@/assets/js/webPushNotification'
  export default {
    name: 'home',
    mixins: [metaElements, appMixins],
    data () {
      return {
        isMounted: false,
        keepExploringData: {},
        isDesktop: this.$parent.isDesktop,
        homeData: {gallery: [], clients: [], homeTiles: [], categories: []},
        clientPath: process.env.IMG_BASE_URL + process.env.ARTIST_IMG,
        htpath: process.env.IMG_BASE_URL + process.env.SLIDER_IMG,
        hpath: process.env.IMG_BASE_URL + process.env.CATEGORY_IMG,
        staticImg: process.env.STATIC_IMG,
        homepath: process.env.IMG_BASE_URL + process.env.HOME_IMG,
        timerData: {
          startDate: '',
          endDate: '',
          exclusiveDate: '',
          // disappear: '2019-06-08 00:00:00',
          color: '#d99b00',
          liveSaleText: '',
          showEarlyText: false,
          showTimer: false,
          showCountDown: false
        },
        creativeDate: '2020-04-20 00:00:00',
        now: new Date(),
        start: new Date(process.env.BIRTHDAY_SALE_START),
        end: new Date(process.env.BIRTHDAY_SALE_END),
        saleDet: {},
        imageHeight: null,
        googleAdwordsId: process.env.GOOGLE_ADWORDS_ID,
        AppLandingBanners: [
          {
            image: 'https://prod-img.thesouledstore.com/public/theSoul/images/appInstallBlock/AppInstallBlockDesktop.jpg',
            mobile_image: 'https://prod-img.thesouledstore.com/public/theSoul/images/appInstallBlock/AppInstallBlockMobile.jpg',
            is_split_banner: true,
            right_url: ''
          }
        ],
        gaTrackedSlides: new Set()
      }
    },
    components: {
      Countdown: () => import(/* webpackPrefetch: true */ './common/Countdown'),
      Carousel,
      Slide,
      whatsMore: () => import(/* webpackPrefetch: true */ './whatsMore.vue'),
      whatsMoreStories: () => import(/* webpackPrefetch: true */ './whatsMoreStories.vue'),
      whatsMoreBanner: () => import(/* webpackPrefetch: true */ './whatsMoreBanner.vue'),
      BannerPlaceHolderMsg: () => import(/* webpackPrefetch: true */ './common/BannerPlaceHolderMsg'),
      NewArrivalsCard: () => import(/* webpackPrefetch: true */ './common/NewArrivalsCard'),
      TopSellingSection: () => import(/* webpackPrefetch: true */ './common/TopSellingSection'),
      OfficialMerchandiseSection: () => import(/* webpackPrefetch: true */ './common/OfficialMerchandiseSection'),
      FullWidthSquareBanner: () => import(/* webpackPrefetch: true */ './common/FullWidthSquareBanner'),
      CarouselGrid2By2: () => import(/* webpackPrefetch: true */ './common/CarouselGrid2By2'),
      RenderHalfCarouselGrid: () => import(/* webpackPrefetch: true */ './common/RenderHalfCarouselGrid'),
      FullWidthCarouselBanner: () => import(/* webpackPrefetch: true */ './common/FullWidthCarouselBanner'),
      HomeWidgetsWrapper: () => import(/* webpackPrefetch: true */ './HomeWidgetsWrapper.vue')
    },
    computed: {
      ...mapGetters(
        [
          'bannerPlcaeHolderData',
          'exclusiveUser',
          'currencyRsToUSD',
          '_cart',
          'webcategory',
          'homeScreenData',
          'isComboActive',
          'authStatus',
          'webpushInitiator',
          'userInterestTime',
          'user',
          'isSelectedCountryIndia',
          'notFound'
        ]
      ),
      homeLandingBanners: function () {
        if (this.$route.path === '/') {
          const data = this.isComboActive ? this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Landing Web'] : this.homeData && this.homeData.gallery
          return data
        } else {
          let genderMenuData = {}
          switch (this.$route.path) {
            case '/men':
              genderMenuData = this.homeScreenData && this.homeScreenData['Home Screen Web']
              break
            case '/women':
              genderMenuData = this.homeScreenData && this.homeScreenData['Home Screen Web Women']
              break
            case '/kids':
              genderMenuData = this.homeScreenData && this.homeScreenData['Home Screen Web Kids']
              break
            case '/sneakers':
              genderMenuData = this.homeScreenData && this.homeScreenData['Home Screen Web Kids']
              break
            default:
              genderMenuData = {}
          }
          const topBanner = genderMenuData && Object.values(genderMenuData) && Object.values(genderMenuData).find(widgetsArray => this.getType(widgetsArray) === 'full width carousel banner')
          return topBanner && topBanner.length && topBanner.slice(0, topBanner.length - 1)
        }
      },
      homeLandingWidgets: function () {
        let widgets = null
        if (this.$route.path === '/' && !this.isComboActive) {
          widgets = this.homeScreenData
        } else if (this.$route.path === '/men') {
          widgets = this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Screen Web']
        } else if (this.$route.path === '/women') {
          widgets = this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Screen Web Women']
        } else if (this.$route.path === '/kids') {
          widgets = this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Screen Web Kids']
        } else if (this.$route.path === '/sneakers') {
          widgets = this.homeScreenData && Object.keys(this.homeScreenData).length && this.homeScreenData['Home Screen Web Kids']
        }
        return widgets
        // Add `whatsMore` as a widget if the selected country is India

        // if (widgets) {
        //   let newWidgets = {}
        //   let flag = 0
        //   Object.keys(widgets).forEach((key) => {
        //     newWidgets[key] = widgets[key]
        //     // Check if the current widget type is the 2x2 carousel grid
        //     if (this.getType(widgets[key]) === '2X2 carousel grid' && this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmore && this.$route.path === '/men') {
        //       newWidgets['whatsMore'] = ['whatsmore', 'whatsmore']
        //       flag = 1
        //     }
        //   })
        //   if (flag === 1) {
        //     return newWidgets
        //   } else {
        //     if (widgets && this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmore && this.$route.path === '/men') {
        //       widgets['whatsMore'] = [ 'whatsmore', 'whatsmore' ]
        //     }
        //     return widgets
        //   }
        // }
      },
      bannerPlaceHolder: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let homeBannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.product_type === 'HOMESCREEN_MSG_WEB' && bannerData.status === true)
          if (homeBannerObj && Object.keys(homeBannerObj).length) {
            let homeBannerPhObj = {}
            homeBannerPhObj.styles = {
              backgroundColor: homeBannerObj.banner_color,
              color: homeBannerObj.banner_text_color
            }
            homeBannerPhObj.text = homeBannerObj.tag_text
            homeBannerPhObj.status = homeBannerObj.status
            return homeBannerPhObj
          }
        }
      },
      bannerPlaceHolderForFireWorkStoryBlock: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_FIREWORK_STORY_BLOCK_WEB'.toLowerCase())
      },
      bannerPlaceHolderForFireWorkGrid: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_FIREWORK_GRID_WEB'.toLowerCase())
      },
      bannerPlaceHolderForCarouselSize: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_APP_SIZE_MWEB_CAROUSEL'.toLowerCase())
      },
      bannerPlaceHolderForWhatsmore: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'WHATS-MORE-HOME-PAGE-WEB'.toLowerCase())
      },
      bannerPlaceHolderForWhatsmoreStories: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_WHAT_MORE_STORIES_HOMEPAG'.toLowerCase())
      },
      bannerPlaceHolderForWhatsmoreBanner: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_WHAT_MORE_BANNER_HOMEPAGE'.toLowerCase())
      },
      bannerPlaceHolderForGoForAppOnlySale: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'GO_APP_ONLY_SALE_WEB'.toLowerCase())
      },
      isShowOnlyKeepExploringWidget: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Home Screen Page'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_ONLY_KEEP_EXPLORING_VIEW'.toLowerCase())
      }
    },
    watch: {
      isComboActive: function () {
        this.getHomeScreenData()
        if (!Vue.ls.get('tss_homeData')) {
          Vue.ls.on('tss_homeData', this.homeGallary())
        } else {
          this.homeData = Vue.ls.get('tss_homeData')
          this.metaTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.ogTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.ogDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.metaTwitterTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaTwitterDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.$store.dispatch('SET_HOME_FOOTER_TEXT')
          // this.$store.commit('GTAG_EVENT', {eventName: 'crto_homepage',
          //   payload: {
          //     email: this.user && this.user.email
          //   }}
          // )
        }
      },
      homeScreenData () {
        const banners = this.homeLandingBanners
        if (banners && banners.length > 0) {
          const allImagesInvalid = banners.every(element => !this.isValidImageUrlWithFormatCheck(element.image))
          if (allImagesInvalid) {
            this.$router.push('/men')
          }
        }
        if (this.isShowOnlyKeepExploringWidget) {
          this.callUserVisitedProducts()
        }
      },
      _cart: function () {
        this.getSaleDetailsForHome()
      },
      webcategory (newVal, oldVal) {
        const gender = Vue.ls.get('tss_landingCategory')
        if (this.isShowOnlyKeepExploringWidget) {
          this.callUserVisitedProducts()
        }
        if (this.isMounted) {
          this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
            payload: {
              sendTo: this.googleAdwordsId,
              ecomm_pagetype: gender ? gender + '_home' : 'home',
              gender: gender,
              page_title: gender ? gender + '_home' : 'home'
            }}
          )
        }
        this.bannerPageEventHandler(0, 'mounted')
      },
      authStatus (newVal, oldVal) {
        if (this.isShowOnlyKeepExploringWidget) {
          this.callUserVisitedProducts()
        }
      },
      homeLandingBanners (imagesArr) {
        // prefetch LCP image logic
        let imgBreakPointArr = [30, 50, 70, 100, 128, 160, 170, 200, 240, 300, 320, 360, 376, 400, 480, 576, 600, 610, 640, 700, 720, 750, 768, 800, 900, 914, 940, 1000, 1024, 1080, 1100, 1140, 1152, 1200, 1242, 1294, 1300, 1400, 1440, 1500, 1536, 1600, 1700, 1800, 1880, 1920, 2000, 2048, 2100, 2208, 2280]
        let closestGumletRenderWidth = null
        let element = document.getElementsByClassName('tss-body-wrapper')
        let windowWidth = element && element[0] && element[0].clientWidth
        let dpr = window.devicePixelRatio
        if (windowWidth) {
          for (let arr in imgBreakPointArr) {
            if (imgBreakPointArr[arr] >= windowWidth) {
              closestGumletRenderWidth = imgBreakPointArr[arr]
              break
            }
          }
          if (imagesArr) {
            let fragment = document.createDocumentFragment()
            for (let imgData of imagesArr) {
              if (!document.getElementById(`homeBanner_${imagesArr.indexOf(imgData)}`)) {
                let imagePath = this.isDesktop ? (this.isComboActive ? this.getHomeBannerImage(imgData.image) : this.htpath + imgData.image) : (this.isComboActive ? this.getHomeBannerImage(imgData.mobile_image) : this.htpath + imgData.mob_image)
                let s = document.createElement('link')
                s.fetchPriority = (imgData === imagesArr[0] || (imagesArr.length > 1 && imgData === imagesArr[1])) ? 'high' : 'low'
                s.id = `homeBanner_${imagesArr.indexOf(imgData)}`
                s.as = 'image'
                s.rel = 'preload'
                s.href = `${imagePath}?format=webp&w=${windowWidth === 1350 ? 800 : closestGumletRenderWidth}&dpr=${dpr.toFixed(1)}`
                fragment.appendChild(s)
              }
            }
            document.head.insertBefore(fragment, document.head.firstChild)
          }
        }
      }
    },
    methods: {
      setheight: function (event) {
        let image = event.target
        this.imageHeight = image.clientWidth * 0.5
      },
      getType: function (widgetsArray = []) {
        let widgetConfig = widgetsArray && widgetsArray.length > 0 && widgetsArray[widgetsArray.length - 1]
        if (widgetConfig[0] === 'Whats More' && this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmore) {
          return 'whatsmore'
        }
        if (widgetConfig[0] === 'Whats More Stories' && this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmoreStories) {
          return 'whatsmoreStories'
        }
        if (widgetConfig[0] === 'Whats More Banner' && this.isSelectedCountryIndia && this.bannerPlaceHolderForWhatsmoreBanner) {
          return 'whatsmoreBanner'
        }
        return widgetConfig[1] || ''
      },
      getUrl (url) {
        if (url && url.includes('https://view.gmetri.com')) {
          let token = Vue.ls.get('tss_token')
          let email = Vue.ls.get('email')
          if (token && email) {
            return `${url}?token_tss=${token}&user_email=${email}`
          } else {
            return `/login?redirect=${url}?token_tss=&newTab=true`
          }
        } else {
          return url
        }
      },
      getComponetToRender: function (item, key) {
        switch (this.getType(item)) {
          case '1X2 carousel grid':
            return 'RenderHalfCarouselGrid'
          case '2X2 carousel grid':
            return 'CarouselGrid2By2'
          case 'square slider horizontal tiles':
            return 'NewArrivalsCard'
          case 'full width square banner':
            return 'FullWidthCarouselBanner'
          case 'small square horizontal tiles':
            return 'OfficialMerchandiseSection'
          case 'product listing tiles':
            return 'TopSellingSection'
          case 'whatsmore': // New case for whatsmore component
            return 'whatsMore'
          case 'whatsmoreStories': // New case for whatsmore component
            return 'whatsMoreStories'
          case 'whatsmoreBanner': // New case for whatsmore component
            return 'whatsMoreBanner'
          default:
            return null
        }
      },
      triggerCarouselEvents: function (index, bimg) {
        const bannerImpressionData = this.getBannerImpressionData(bimg, index)
        const gender = Vue.ls.get('tss_landingCategory')
        // this.$store.dispatch('TATVIC_EVENT', {eventName: 'HOMEPAGE_BANNER_CLICK', payload: {BANNER_TAG: bimg.tags || bimg.title}})
        let eventPaylod = {
          creative_name: bannerImpressionData.creative_name ? bannerImpressionData.creative_name : 'NA',
          creative_slot: bannerImpressionData.creative_slot || bannerImpressionData.creative_slot === 0 ? bannerImpressionData.creative_slot : 'NA',
          promotion_id: bannerImpressionData.promotion_id ? bannerImpressionData.promotion_id : 'NA',
          creative_image: bannerImpressionData && bannerImpressionData.creative_img ? bannerImpressionData.creative_img : 'NA',
          promotion_name: 'Home Bnnner Carousel',
          promotion_tab: this.webcategory || 'NA'
        }
        this.$store.dispatch('ECOMMERCE_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
        this.$store.commit('GTM_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
        this.$store.commit('GTAG_EVENT', {eventName: 'home.carousel.click', payload: {slider_index: index}})
        this.$store.commit('SET_NAVIGATION_WIDGET', 'Top Banner')
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-SECTION',
          payload: {
            Section_Name: String(bimg.title || bimg.tags || 'Home Banner'),
            Section_Index: Number(index),
            Product_Category: String(bimg.category),
            Product_Name: String(bimg.promotion_name),
            Product_ID: Number(bimg.id),
            Product_Price: '',
            Product_Artist: String(bimg.artist),
            ProductImage_URL: this.isComboActive ? this.getHomeBannerImage(bimg.image) : `${this.htpath}${bimg.image}`,
            Product_URL: bimg.navigation_link || bimg.link,
            GENDER: gender
          }}
        )
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'BANNER',
          payload: {
            Index_position: index,
            Description: bimg.title || bimg.tags,
            BannerURL: bimg.navigation_link || bimg.link,
            'Sub-Category': '',
            Category: '',
            Theme: ''
          }}
        )
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'BANNER_CLICKED',
          payload: {
            Index_position: Number(index),
            Description: String(),
            Destination_URL: String(bimg.navigation_link),
            Source_URL: String(),
            Sub_Category: String(),
            Category: String(bimg.category),
            Theme: String()
          }}
        )
      },
      callUserVisitedProducts () {
        if (this.isShowOnlyKeepExploringWidget) {
          const gender = Vue.ls.get('tss_landingCategory')
          let payload = {
            gender: gender === 'men' ? 1 : gender === 'women' ? 2 : 1,
            isKid: gender === 'kids',
            authStatus: this.authStatus
          }
          const type = 'GET_USER_VISITED_PRODUCT'
          const componentType = ['Pick up Where You Left Off', 'product listing tiles', 'Pick up Where You Left Off']
          const heading = 'User Visited Product'
          this.userVisitedProducts(type, componentType, heading, payload)
        }
      },
      userVisitedProducts (type, componentType, heading, payload) {
        if (!this.authStatus) {
          let recentViewProducts = Vue.ls.get('recentViewProducts')
          payload.recentViewProducts = recentViewProducts
        }
        this.activeWidgetLink = false
        this.keepExploringData = {}
        this.$store.dispatch(type, payload).then(response => {
          response && response.response && response.response.products.push(componentType)
          if (response && response.response && response.response.products && response.response.products.length > 1) {
            if (this.isShowOnlyKeepExploringWidget) {
              this.keepExploringData = {
                [heading]: response.response.products
              }
            }
          } else {
            this.keepExploringData = {}
          }
        }).catch(error => {
          console.log('error:', error)
        })
      },
      redirectToAppStore: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'App_Banner_Click', payload: {}})
        if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.thesouledstore'
        } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
          window.location.href = 'https://apps.apple.com/in/app/thesouledstore/id1493897434'
        } else {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.thesouledstore'
        }
      },
      formatTime: function (date) {
        let d = date ? new Date(date) : new Date()
        return [
          d.getFullYear(),
          ('0' + (d.getMonth() + 1)).slice(-2),
          ('0' + d.getDate()).slice(-2)
        ].join('-') + ' ' +
          [('0' + d.getHours()).slice(-2),
            ('0' + d.getMinutes()).slice(-2),
            ('0' + d.getSeconds()).slice(-2)
          ].join(':')
      },
      homeGallary () {
        this.$set(this.$parent, 'loading', true)
        return this.axios.get(process.env.APP_URL + 'home-gallery').then(response => {
          this.homeData = response.data
          this.metaTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.ogTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.ogDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.metaTwitterTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaTwitterDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.$parent.footerTextMixin = response.data.homeFooterText
          this.$set(this.$parent, 'loading', false)
          Vue.ls.set('tss_homeData', response.data, 30 * 60 * 1000)
          Vue.ls.set('tss_footerText', response.data.homeFooterText, 30 * 60 * 1000)
          this.$store.dispatch('SET_HOME_FOOTER_TEXT', response.data.homeFooterText)
        })
      },
      arraytoString (ab) {
        var b = process.env.IMG_BASE_URL + process.env.CATEGORY_IMG + ab.replace('[', '').replace(']', '').replace('"', '').replace('"', '')
        return b
      },
      hmtilebox: function (ind) {
        if (typeof this.homeData.categories[ind] === 'undefined') {
          return false
        } else {
          return this.homeData.categories[ind]
        }
      },
      getExtension: function (filename) {
        var parts = filename && filename.split('.')
        return parts && parts[parts.length - 1]
      },
      getHomeScreenData: function () {
        this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive})
      },
      getSaleTextToShow () {
        let saleDetails = this.saleDet
        let excStartDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
        let excEndDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
        let nonExcStartDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
        let nonExcEndDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
        this.now = this.formatTime()
        if ((this.exclusiveUser || this.isExclusive) && saleDetails.early_access) {
          if (moment(this.now) >= moment(excStartDate) && moment(this.now) < moment(excEndDate)) {
            if (saleDetails.early_access) this.timerData.liveSaleText = saleDetails.pre_early_access_text
            else this.timerData.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            return saleDetails.pre_early_access_text
          } else if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.timerData.liveSaleText !== saleDetails.early_access_text) this.timerData.liveSaleText = saleDetails.early_access_text
            this.timerData.showEarlyText = true
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            return
          }
          // show timer
          if (this.timerData.showTimer) this.timerData.showTimer = false
          if (this.timerData.showCountDown) this.timerData.showCountDown = false
        } else {
          if (moment(this.now) >= moment(nonExcStartDate) && moment(this.now) < moment(nonExcEndDate)) {
            if (this.timerData.liveSaleText !== saleDetails.pre_live_sale_text) this.timerData.liveSaleText = saleDetails.pre_live_sale_text
            // show timer
            if (!this.timerData.showCountDown) this.timerData.showCountDown = true
            return
          }
          // show timer
          if (this.timerData.showTimer) this.timerData.showTimer = false
          if (this.timerData.showCountDown) this.timerData.showCountDown = false
        }
      },
      saleBanner: function (saleDetails) {
        this.now = this.formatTime()
        if (saleDetails && Object.keys(saleDetails).length) {
          this.saleDet = saleDetails
          this.timerData.showTimer = saleDetails.timer_status
          if (saleDetails.add_cart_status_web) {
            // need to add logic for disabling the add to cart button
          } else {
            // need to add logic for change cart text & its color
          }
          // early access true & user is exclusive
          if (saleDetails.early_access && (this.exclusiveUser || this.isExclusive)) {
            this.timerData.exclusiveDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            this.timerData.startDate = this.$parent.formatDateSale(saleDetails.show_exclusive_date_time)
            this.timerData.endDate = this.$parent.formatDateSale(saleDetails.show_exclusive_end_date_time)
          } else {
            this.timerData.startDate = this.$parent.formatDateSale(saleDetails.show_start_date_time)
            this.timerData.endDate = this.$parent.formatDateSale(saleDetails.show_end_date_time)
          }
        }
        this.getSaleTextToShow()
      },
      getSaleDetailsForHome: function () {
        if (this._cart && Object.keys(this._cart).length) {
          this.$store.dispatch('GET_SALE_DETAILS', 'Web_Home').then(response => {
            this.saleBanner(response)
          })
        }
      },
      getBannerImpressionData (obj, index) {
        if (obj) {
          return {
            promotion_id: obj.id || '',
            promotion_name: obj.promotion_name || '',
            creative_name: obj.title || obj.tags || '',
            creative_slot: index,
            creative_img: this.isDesktop ? obj.image : obj.mob_image || 'NA',
            currency: 'INR'
          }
        }
      },
      isElementInViewport (el) {
        var rect = el.getBoundingClientRect()
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
      },
      bannerPageEventHandler (index, caller) {
        let visibleBanner = this.homeLandingBanners && this.homeLandingBanners[index]
        let data = this.getBannerImpressionData(visibleBanner, index)
        var isDuplicate = false
        window.dataLayer.forEach(dat => {
          if (dat && dat[1] === 'view_promotion' && dat[2] && dat[2] && dat[2].promotion_id && dat[2].promotion_id === data && data.promotion_id && dat[2].creative_slot === data && data.creative_slot) {
            isDuplicate = true
          }
        })
        if (!this.gaTrackedSlides.has(this.webcategory + index) && visibleBanner) {
          this.$store.commit('GTM_EVENT', {
            eventName: 'view_promotion',
            payload: {
              creative_name: data && data.creative_name ? data.creative_name : 'NA',
              creative_slot: data && (data.creative_slot || data.creative_slot === 0) ? data.creative_slot : 'NA',
              creative_image: data && data.creative_img ? data.creative_img : 'NA',
              promotion_id: data && data.promotion_id ? data.promotion_id : 'NA',
              promotion_name: 'Home Bnnner Carousel',
              promotion_tab: this.webcategory || 'NA'
            }
          })
          this.gaTrackedSlides.add(this.webcategory + index)
        }
        if ((caller === 'mounted' || this.isElementInViewport(this.$refs[`my-carousel`].$el)) && !isDuplicate) {
          this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'view_promotion',
            payload: {
              creative_name: data && data.creative_name ? data.creative_name : 'NA',
              creative_slot: data && (data.creative_slot || data.creative_slot === 0) ? data.creative_slot : 'NA',
              promotion_id: data && data.promotion_id ? data.promotion_id : 'NA',
              promotion_name: data && data.promotion_name ? data.promotion_name : 'NA'
            }
          })
        }
      },
      getHomeBannerImage (img) {
        return img && img.length && img.includes('https://img.thesouledstore.com') ? img.replace('https://img.thesouledstore.com', 'https://prod-img.thesouledstore.com') : img
      },
      loadimage (e) {
        e.target && e.target.classList.add('customFade-active')
      },
      appOpenHandler (deviceOs) {
        if (deviceOs === 'Play Store') {
          const url = 'intent://thesouledstore.com/#Intent;scheme=https;package=com.thesouledstore;end'
          window.location.replace(url)
        } else if (deviceOs === 'App Store') {
          window.location.replace('https://bit.ly/appxtss')
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      if (to.query && to.query.utm_source) {
        Vue.ls.set('utm_value',
          {
            utm_source: to.query.utm_source,
            utm_medium: to.query.utm_medium,
            utm_campaign: to.query.utm_campaign,
            utm_content: to.query.utm_content,
            utm_url: to.fullPath,
            utm_term: to.query.utm_term
          }
        )
      }
      Vue.ls.set('routeObj',
        {current: getLastPage(to.name), previous: getLastPage(from.name) || ''})
      next()
    },
    mounted: function () {
      this.now = this.formatTime()
      const minutes = parseInt(Math.abs(new Date().getTime() - this.userInterestTime) / (1000 * 60) % 60)
      const gender = Vue.ls.get('tss_landingCategory')
      if (!this.isDesktop) {
        this.$store.commit('SET_FOOTER_COLLAPSE_CONTROL', {
          expanded: false,
          expandedClass: '', // '' or show
          bottomStyle: 'margin-bottom: 0px;'
        })
      }
      this.$store.commit('SET_LISTING_LANDING_DATE', new Date())
      if (this.webpushInitiator && minutes >= 2) {
        webPush.webpushSubscription().then(() => {
          this.$store.commit('WEBPUSH_INITIATOR', false)
        })
      }
      Vue.ls.remove('pdp_checkDrop')
      if (gender === 'men') {
        this.$store.commit('GTAG_EVENT', {eventName: 'Men',
          payload: {
            id: this.user.user_id
          }}
        )
      }
      if (gender === 'women') {
        this.$store.commit('GTAG_EVENT', {eventName: 'Women',
          payload: {
            id: this.user.user_id
          }}
        )
      }
      if (gender !== 'women' && gender !== 'men') {
        this.$store.commit('GTAG_EVENT', {eventName: 'ct_page_viewed_custom', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
        this.$store.commit('GTAG_EVENT', {eventName: 'Page_Viewed', payload: {pdp_response: (Vue.ls.get('routeObj')).current}})
      }
      if (this.isShowOnlyKeepExploringWidget) {
        this.callUserVisitedProducts()
      }
      if (!this.isMounted) {
        this.$store.commit('GTAG_EVENT', {eventName: 'page_view',
          payload: {
            sendTo: this.googleAdwordsId,
            ecomm_pagetype: gender ? gender + '_home' : 'home',
            gender: gender,
            page_title: gender ? gender + '_home' : 'home'
          }}
        )
      }
      setTimeout(() => {
        this.isMounted = true
      }, 500)
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      const schemaData = {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        'name': 'The Souled Store',
        'image': 'https://www.thesouledstore.com/logo.png',
        '@id': 'https://www.thesouledstore.com',
        'url': 'https://www.thesouledstore.com',
        'telephone': '+91-1234567890',
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': '123 Main Street',
          'addressLocality': 'Mumbai',
          'postalCode': '400001',
          'addressCountry': 'India'
        }
      }

      script.textContent = JSON.stringify(schemaData)
      document.head.appendChild(script)
    },
    created: function () {
      if (this.isComboActive !== '') {
        this.getHomeScreenData()
        if (!Vue.ls.get('tss_homeData')) {
          Vue.ls.on('tss_homeData', this.homeGallary())
        } else {
          this.homeData = Vue.ls.get('tss_homeData')
          this.metaTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.ogTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.ogDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.metaTwitterTitle = 'Online Shopping for Men & Women Clothing, Accessories at The Souled Store'
          this.metaTwitterDescription = 'Shop for t-shirts, joggers, backpacks for men and women online at The Souled Store - the one-stop destination for all official merchandise of superheroes and movies.'
          this.$store.dispatch('SET_HOME_FOOTER_TEXT')
          // this.$store.commit('GTAG_EVENT', {eventName: 'crto_homepage',
          //   payload: {
          //     email: this.user && this.user.email
          //   }}
          // )
        }
      }
      this.$store.dispatch('RESET_FOOTER_TEXT')
      this.bannerPageEventHandler(0, 'mounted')
    },
    beforeDestroy () {
      this.$store.commit('SET_NOT_FOUND_FALSE')
      this.$store.commit('SET_LISTING_LANDING_DATE', '')
      window.dataLayer.length = 0
    }
  }
</script>
<style lang="css" scoped>
  [v-cloak] {
    background: #ed2d2f;
  }
  .show-more-btn{
    position: absolute;
    width: 100%;
    bottom: 16%;
    text-align: center;
  }
  .show-more-btn-txt {
    display: inline;
    color: rgb(0, 0, 0);
    border-color: rgb(4, 251, 251);
    border-style: solid;
    border-width: 2px;
    background: rgb(4, 251, 251) none repeat scroll 0% 0%;
  }
  .fullWidth {
    width:100%;
  }
  .loadingBanner{
    width: 100%;
    height: 491px;
    object-fit: cover;
  }
  .clickable{
    cursor: pointer;
  }
  .shimmerBgColor{
    background-color: #FCEAE7; 
  }
  .zoom {
    transition: transform .2s;
    width: 100%;
    height: 100%;
    margin: 0px auto;
  }
  .splitted-navigation-container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .zoom:hover {
    -ms-transform: scale(1.1); /* IE 9 */
    -webkit-transform: scale(1.1); /* Safari 3-8 */
    transform: scale(1.1);
    -webkit-transition: all 0.3s ease-in;
  }

  .exclusive-bar {
    background-color: #3498db;
    color: #fff;
    padding: 10px;
  }
  .glow {
    transition: opacity .15s ease-in;
  }
  .glow:hover,
  .glow:focus {
    opacity: 1;
    transition: opacity .15s ease-in;
  }
  .minHeight{
    min-height: 450px;
  }


  .tilethumb {
    margin-bottom: 7px;
    position: relative;
    height: 100%;
  }

  .socialsection {
    padding: 0px 0 0 0;
  }

  .htilebtn {
    color: #fff;
    font-size: 1.6em;
    z-index: 9;
    padding-left: 8px;
    padding-bottom: 7px;
    line-height: 1em;
    bottom: 0px;
    top: unset;
  }

  .category-heading {
    margin: 1.5rem 0;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
  }

  .countdown-text {
    font-size: 40px;
  }

  .headtop {
    background-color: #ffffff;
  }
  .lined-heading {
    margin-top: 20px;
  }

  .discount-container {
    margin-top: 30px;
  }

  .discount-info {
    box-shadow: 0px -2px 3px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: absolute;
    background: white;
    color:#353535;
    padding: 14px 0 20px 0;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    z-index: 10;
    text-align: center;

  }

  .discount-info--1 {
    font-size: 20px;
    font-family: 'source_sans_prosemibold';
    margin: 0 0 5px 0;
    text-transform: uppercase;
  }

  .discount-info--2 {
    font-size: 18px;
    font-family: 'source_sans_prosemibold';
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    .home-background {
      background-color: #f7f7f7;
      box-sizing: border-box !important;
      overflow-x: hidden;
      /* min-height: 2471px; */
    }
    .loadingBanner{
      height: 45%;
    }
    .minHeight{
    min-height: 292px;
  }
    .headtop .prelative {
      /* min-height: 292px */
    }
    .home-tiles {
      background-color: #ffffff;
    }
    .headtop {
      padding-bottom: 0.3rem;
    }
    .category-heading {
      margin: 1rem 0;
    }
  }

  @media screen and (max-width: 991px) {

    /* .home-background {
      min-height: 2491px;
    } */

    .htilebtn {
      font-size: 1.3em;
    }

    .lined-heading {
      margin-top: 10px;
    }

    .mob_mb7 {
      margin-bottom: 7px;
    }

    .homeboxes .bx {
      padding-right: 3.5px !important;
      padding-left: 3.5px !important;
      float: left;
    }

    .homeboxes .row {
      margin-left: -3.5px;
      margin-right: -3.5px;
    }

    .container {
      padding-right: 7px;
      padding-left: 7px;
    }

    .tileHead {
      margin-bottom: 5px;
    }
    .countdown-text {
      font-size: 18px;
      margin-bottom: 10px;
    }
  }

  @media screen and (min-width: 992px) {

    /* .home-background {
      min-height: 2832px;
    } */

    .headtop .prelative {
      min-height: 339px
    }
    .homeboxes .bx {
      padding-right: 5px;
      padding-left: 5px;
      float: left;
    }

    .homeboxes .row {
      margin-left: -5px;
      margin-right: -5px;
    }
    .exclusive-tile {
      margin-bottom: 14px;
    }
  }

  @media (min-width: 1200px) {
    /* .home-background {
      min-height: 2491px;
    } */

    .headtop .prelative {
      min-height: 430px
    }

    .tilethumb {
      margin-bottom: 19px;
    }

    .homeboxes .bx {
      padding-right: 7px;
      padding-left: 7px;
      float: left;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@media screen and (max-width: 480px) {
  .home-background .VueCarousel-slide {
    visibility: visible;
    flex-basis: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?45320e28